'use strict';

/**
 * Helper method to map errors to keys.
 */ const mapErrorsToKeys = (fieldError)=>Object.keys(fieldError?.types ?? {});

exports.mapErrorsToKeys = mapErrorsToKeys;
//# sourceMappingURL=mapErrorsToKeys.js.map
